import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mantine/core";
import { Component } from "react";
const ErrorDisplay = ({ message, stack }) => {
    return (_jsxs(Stack, { w: "100%", h: "100%", p: "sm", children: ["Error:", message, stack] }));
};
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            message: error.message,
            stack: error.stack,
            hasError: true,
        };
    }
    render() {
        const { state: { hasError, message, stack }, props: { children }, } = this;
        if (hasError) {
            return _jsx(ErrorDisplay, { stack: stack, message: message });
        }
        return children;
    }
}
